import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: {
      'it-it': ['it'],
      'it-IT': ['it'],
      default: ['en']
    },
    load: 'languageOnly',
    whitelist: ['en', 'it', 'it-it', 'it-IT'],
    debug: true, // Should be disabled in production environment.

    interpolation: {
      escapeValue: false // Not needed for React as it escapes by default.
    }
  });

export { i18n };
